import axios from "axios";
import { getToken, QuestionType } from "./service";
import qs from "qs";
import { PaperType, StuPaper, TopicType, StuTopics } from "./homework";
import Config from "../config";
import _ from "underscore";
import { OrderTopicType } from "pages/exam/addExam";
import Storage from "../utils/Storage";
import { download } from "utils/common";
import { Key } from "react";

export enum ExamType {
    Exam = "1", // 线上考试
    Thesis = "2", //论文
    Oral = "3" //口头
}

export enum ExamTimeWay {
    unify = "1", //统一时间
    free = "2" //学生自由安排
}

export enum banState {
    confirm = "1", //禁考
    cancel = "0" //取消禁考
}

export enum CatchPhoto {
    open = "1", //启用抓拍
    close = "0" //禁用抓拍
}

export type StatusType = "all" | "joined" | "unJoin" | "submitted";

export interface FilterValue {
    status: StatusType; // 全部/已签到/未签到
    text: string;
}

export function getExamTypeName(type: ExamType) {
    const map: any = { 1: "线上考试", 2: "论文考核", 3: "口试" };
    return map[type];
}

export interface CourseListItem {
    courseName: string;
    courseNo: string;
    courseSeq: string;
    courseId: number;
}

export interface ExamListItem {
    examId: string; //考核ID
    type: ExamType;
    name: string; //考核名称
    createuser: string;
    editable: BooleanValue;
    examInfo: string;
    isPublish: BooleanValue;
    startTime: string;
    endTime: string;
    studentDo: BooleanValue;
    seed: BooleanValue;
    courseList: CourseListItem[];
    createExamTeacherName: string; //创建人
    createTeacherNo: string; //创建人编号
    isInvigilator: BooleanValue; //是否是监考老师 1:是
    duration: string; //考试时限
    timeType: ExamTimeWay; //开考时间, 1统一时间, 2学生自主安排
    realtimeVideo?: BooleanValue;
    catchPhoto?: BooleanValue;
    optionSeed: BooleanValue;
    isImport: BooleanValue;
    isSetTopicTeacher: BooleanValue; //是否是出题老师
}

export interface ExamPaperItem {
    score: string;
    checkFlag: string;
    studnetSubmit: BooleanValue;
    name: string;
    studentNo: string;
    studentId: string;
    department: string;
    subject: string;
    className: string;
    courseName: string;
    courseNo: string;
    courseSeq: string;
    objectiveScore: string;
    paperId: string;
    examId: string;
    times: BooleanValue;
    ban: BooleanValue; //是否禁考， 1禁考
    stuHaveExamFlag: BooleanValue; //是否被标记， 1有标记
}

/**
 * 获取考试列表
 */
export function getExamList() {
    const token = getToken();
    return axios
        .get<SuccessData<ExamListItem[]>>(`teacher/getExamList`, {
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 查询考核接口
 */
export function getExamInfo(examId: string) {
    const token = getToken();
    return axios
        .get<SuccessData<ExamListItem>>(`teacher/getExamInfo`, {
            params: { examId },
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 获取考试的课程列表
 */
export function getExamCourseList() {
    const token = getToken();
    return axios
        .get<SuccessData<CourseListItem[]>>(`teacher/getExamCourseList`, {
            headers: { token }
        })
        .then(res => res.data.data);
}

interface ExamInfoParams {
    examId?: string;
    name: string;
    type: ExamType;
    startTime: string;
    endTime: string;
    seed?: BooleanValue; //试题是否乱序, 0不乱, 1乱序
    courses: CourseListItem[];
    optionSeed?: BooleanValue; //选项是否乱序, 0不乱, 1乱序
    timeType?: ExamTimeWay; //开考时间, 1统一时间, 2学生自主安排
    duration?: number; //考试时限. 学生自主安排时, 考试时长, 默认120
    realtimeVideo?: BooleanValue; //实时监控 0禁用, 1启用, 默认禁用
    catchPhoto?: BooleanValue; //摄像头抓拍 0禁用, 1启用, 默认禁用
}

/**
 * 保存试卷
 */

export function saveExamInfo(data: ExamInfoParams) {
    const token = getToken();

    const postData = {
        ...data,
        courses: JSON.stringify(data.courses),
        seed: data.type === ExamType.Exam ? data.seed : undefined,
        optionSeed: data.type === ExamType.Exam ? data.optionSeed : undefined,
        realtimeVideo:
            data.type === ExamType.Exam
                ? Number(data.realtimeVideo)
                : undefined,
        catchPhoto:
            data.type === ExamType.Exam ? Number(data.catchPhoto) : undefined,
        duration:
            data.type === ExamType.Exam && data.timeType === ExamTimeWay.free
                ? data.duration
                : undefined,
        timeType: data.type === ExamType.Exam ? data.timeType : undefined
    };

    return axios.post(`teacher/saveExamInfo`, qs.stringify(postData), {
        headers: { token }
    });
}

/**
 * 获取我考核下的课程
 * @param examId 考核ID
 */
export function getExamMyCourseList(examId: string) {
    const token = getToken();
    return axios
        .get<SuccessData<CourseListItem[]>>(`teacher/getExamMyCourseList`, {
            params: { examId },
            headers: { token }
        })
        .then(res => res.data.data);
}

/**
 * 学生试卷列表
 * @param params
 */
export function getStudentExamPaperList(params: {
    courseNo: string;
    courseSeq: string;
    examId: string;
    batchNo?: string;
}) {
    const { batchNo, ...formData } = params;
    return axios
        .get<SuccessData<ExamPaperItem[]>>(`teacher/getStudentExamPaperList`, {
            params: formData,
            headers: { batchNo }
        })
        .then(res => res.data.data);
}

/*
 * 删除考核接口
 * @param examId
 */
export function deleteExamInfo(examId: string) {
    const token = getToken();
    return axios.post(`teacher/deleteExamInfo`, qs.stringify({ examId }), {
        headers: { token }
    });
}

/**
 * 发布考核
 */
export function examPublish(examId: string) {
    const token = getToken();
    return axios.post(`teacher/examPublish`, qs.stringify({ examId }), {
        headers: { token }
    });
}

/**
 * 取消发布考核
 */
export function examCancel(examId: string) {
    const token = getToken();
    return axios.post(`teacher/examCancel`, qs.stringify({ examId }), {
        headers: { token }
    });
}

/**
 * 获取服务器时间
 */
export function getCurrentTime() {
    const token = getToken();
    return axios
        .get<SuccessData<string>>(`teacher/getCurrentTime`, {
            headers: { token }
        })
        .then(res => res.data.data);
}

export interface ExamPaperData
    extends Omit<PaperType, "ispublish" | "isHomeworkComplete"> {
    paperId: string;
}

/**
 * 获取试题列表
 */
export function getExamPaper(paperId: string) {
    const token = getToken();

    return axios
        .get<SuccessData<ExamPaperData | EmptyValue>>("teacher/getExamPaper", {
            params: { paperId },
            headers: { token }
        })
        .then(res => res.data.data)
        .then(data => {
            if (!data) return data;
            if (!data.topics) return data;

            const topics = data.topics.map(item => {
                item.tempTopicId = item.topicId || Math.random().toString();
                item.topics.map(item => {
                    item.tempTopicId = item.topicId || Math.random().toString();
                    return item;
                });
                return item;
            });
            return { ...data, topics };
        });
}

/**
 * 获取试题列表
 */
export function getThesisPaper(paperId: string) {
    return getExamPaper(paperId).then(data => (data ? data.topics[0] : null));
}

/**
 * 增加或修改考核试卷试题接口
 */
export function saveExamTopic(
    topicId: string | EmptyValue,
    trunk: string,
    type: QuestionType,
    topic: TopicType,
    examId: string,
    paperId?: string | EmptyValue
) {
    const token = getToken();

    return axios
        .post<SuccessData<string>>(
            "teacher/saveExamTopic",
            qs.stringify({
                paperId,
                topicId,
                trunk,
                type,
                answers: JSON.stringify(topic.answers),
                score: topic.score,
                contentText: topic.contentText,
                examId,
                topics: JSON.stringify(
                    topic.topics.map(topic => ({
                        ...topic,
                        paperId,
                        type: topic.topicType
                    }))
                )
            }),
            { headers: { token } }
        )
        .then(res => res.data.message);
}

/**
 * 删除题目
 * @param topics
 */
export function deleteExamTopic(topics: TopicType[]): Promise<void> {
    const token = getToken();
    const ids = topics.filter(item => item.topicId).map(item => item.topicId);
    if (ids.length === 0) return Promise.resolve();
    return axios.post(
        `teacher/deleteExamTopic`,
        qs.stringify({ topics: ids.join(",") }),
        { headers: { token } }
    );
}

export interface LunWenStuTopics extends StuTopics {
    comment: string;
}

interface StudentInfo {
    ban: string; //是否禁用
    paperId: string; //试卷id
    studentId: string; //学生id
    studentNo: string; //学号
}

// type StudentExamPaperInfo = Omit<StuPaper, "courseName">;
interface StudentExamPaperInfo extends Omit<StuPaper, "courseName"> {
    topics: LunWenStuTopics[];
    paperName: string;
    nextStudent: StudentInfo;
    preStudent: StudentInfo;
    uploadFiles: string[]; //学生端上传的附件列表
}

/***
 * 获取学员作业详细
 */
export function getStudentExamPaperInfo(args: {
    paperId: string;
    studentId: string;
    batchNo?: string;
}) {
    const { batchNo, ...formData } = args;
    const token = getToken();
    return axios
        .get<SuccessData<StudentExamPaperInfo>>(
            `teacher/getStudentExamPaperInfo`,
            { params: formData, headers: { token, batchNo } }
        )
        .then(res => res.data.data);
}

export interface OralScore {
    studentId: string;
    score: number;
    channelId: string;
    examId: string;
}

/**
 * 保存口试成绩
 * @param data
 */
export function saveOralScore(data: OralScore[]) {
    const token = getToken();
    return axios.post<SuccessData<string>>(
        `teacher/saveOralScore`,
        qs.stringify({ examChannelPaperList: JSON.stringify(data) }),
        { headers: { token } }
    );
}

/**
 * 主观题判分
 * @param args
 */
export function savePaperScore(args: {
    paperId: string;
    studentId: string;
    topicId: number;
    examId: string;
    score?: number;
    comment?: string;
}) {
    const token = getToken();
    return axios.post(`teacher/savePaperScore`, qs.stringify(args), {
        headers: { token }
    });
}

/**
 * 下载表格
 */
export function downStudentExamPaperList(args: {
    courseNo: string;
    courseSeq: string;
    examId: string;
    type: ExamType;
}) {
    const token = getToken();
    const batch = Storage.get("batch") || Config.DefaultBatch;
    window.location.href = `${
        Config.ApiHost
    }teacher/downStudentExamPaperList?token=${btoa(token || "")}&${qs.stringify(
        { ...args, batchNo: batch }
    )}`;
}

/**
 * 导出（填空题不自动判分）
 */
export function downStuExamScore(args: {
    courseNo: string;
    courseSeq: string;
    examId: string;
    type: ExamType;
}) {
    const token = getToken();
    const batch = Storage.get("batch") || Config.DefaultBatch;
    window.location.href = `${
        Config.ApiHost
    }teacher/downStuExamScore?token=${btoa(token || "")}&${qs.stringify({
        ...args,
        batchNo: batch
    })}`;
}

export function topicSort(topics: OrderTopicType[]) {
    const token = getToken();
    const ids = _.sortBy(topics, topic => topic.order).map(
        item => item.topicId
    );
    if (ids.length === 0) return Promise.resolve();
    return axios.post(
        `teacher/topicSort`,
        qs.stringify({ topics: ids.join(",") }),
        { headers: { token } }
    );
}

export function paperTopicSort(paperId: string, types: string[]) {
    const token = getToken();
    return axios.post(
        `teacher/paperTopicSort`,
        qs.stringify({ paperId, types: types.join(",") }),
        { headers: { token } }
    );
}

export function collectingStuPaper(
    examId: string,
    paperId: string,
    studentNo: string
) {
    const token = getToken();
    return axios.get(`teacher/collectingStuPaper`, {
        params: { examId, paperId, studentNo },
        headers: { token }
    });
}

export enum ExamStatus {
    NotStarted = "未开始", //未开始
    doing = "进行中", // 进行中
    done = "已结束" // 已结束
}

export interface ExamPaperListItem {
    paperId: string;
    paperName: string;
}

// 获取考核下的试卷列表

export function getExamPaperList(examId: string) {
    const token = getToken();
    return axios
        .post<SuccessData<ExamPaperListItem[]>>(
            `/teacher/getExamPaperList`,
            qs.stringify({ examId }),
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data =>
            data.map(item => {
                return { ...item, paperId: item.paperId + "" };
            })
        );
}

// 删除考核中的试卷
export function deleteExamPaper(examId: string, paperId: string) {
    const token = getToken();
    return axios.post(
        `/teacher/deleteExamPaper`,
        qs.stringify({ examId, paperId }),
        { headers: { token } }
    );
}

export interface InvigilationListItem {
    stuId: string;
    rowNo: number; //行号
    stuName: string; //学生姓名
    stuNo: string; //学号
    firstStartTime: string; //第一次打开试卷时间
    submitTime: string; //提交时间
    submitStatus: BooleanValue; //提交状态: 1:已提交 0:未提交
    joinStatus: BooleanValue; //参与状态:1:已参与 0:未参与
    subFileSum: string; //附件数
    haveExamFlag: BooleanValue; //异常表示: 0:无，1：有
    ban: BooleanValue; //禁考标识
    catchPhoto: BooleanValue; //抓拍
    courseNo: string;
    courseSeq: string;
    courseInfo: string;
}

interface InvigilationList {
    submitCount: number; //提交数
    courseNumber: number; //课程总人数
    unJoinInCount: number;
    joinInCount: number;
    data: InvigilationListItem[];
}
// 监考列表
export function getInvigilationList(params: {
    courseId: string;
    examId: string;
    isInvigilator: string;
}) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios
        .get<SuccessData<InvigilationList>>(
            `/teacher/getInvigilationList?courseId=${params.courseId}&examId=${params.examId}&batchNo=${batchNo}&isInvigilator=${params.isInvigilator} `,
            { headers: { token } }
        )
        .then(res => res.data.data)
        .then(data => {
            const newData = data.data.map(item => ({
                ...item,
                courseInfo: item.courseNo + "-" + item.courseSeq
            }));
            return { ...data, data: newData };
        })
        .then(data => {
            const onSelect: { [key: string]: any } = {};
            data.data.map(item => {
                const { courseInfo } = item;
                if (!_.has(onSelect, courseInfo)) onSelect[courseInfo] = item;
            });

            return {
                submitCount: data.submitCount,
                courseNumber: data.courseNumber,
                unJoinInCount: data.unJoinInCount,
                joinInCount: data.joinInCount,
                data: data.data,
                onSelect: _.values(onSelect)
            };
        });
}

// 禁考/取消禁考
export function updateBanStatus(
    examId: string,
    status: string,
    stuNo: string,
    banInfo?: string
) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post(
        `/teacher/updateBanStatus`,
        qs.stringify({ examId, status, stuNo, banInfo }),
        { headers: { token, batchNo } }
    );
}

// 监考页面修改单人,批量抓拍
export function updateCatchPhoto(
    examId: string,
    status: string,
    stuNo: string,
    course?: string
) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post(
        `/teacher/updateCatchPhoto`,
        qs.stringify({ examId, status, stuNo, course }),
        { headers: { token, batchNo } }
    );
}

// 监考页面是否允许手机端是上传
export function updatePhoneUpload(
    examId: string,
    status: string,
    stuNo: string,
    course?: string
) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post(
        `/teacher/updatePhoneUpload`,
        qs.stringify({ examId, status, stuNo, course }),
        { headers: { token, batchNo } }
    );
}

// 是否可以下载试卷
export function updatePaperDownload(
    examId: string,
    status: string,
    stuNo: string,
    course?: string
) {
    const token = getToken();
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post(
        `/teacher/updatePaperDownload`,
        qs.stringify({ examId, status, stuNo, course }),
        { headers: { token, batchNo } }
    );
}

interface ExamInfos {
    name: string; //考试名
    id: number; //考核ID
    beginTime: string; //开始时间
    endTime: string; //结束时间
    timeType?: ExamTimeWay; //开考时间, 1统一时间, 2学生自主安排
}

// 监考列表的考核信息
export function getExamInfos(examId: string) {
    const token = getToken();
    return axios
        .post<SuccessData<ExamInfos>>(
            `/teacher/getExamInfos`,
            qs.stringify({ examId }),
            { headers: { token } }
        )
        .then(res => res.data.data);
}

interface ExamFlagPaparms {
    id?: number; //新增不传 修改需要传
    studentNo: string; //学号
    flag: string; //标记
    examId: string; //考核id
}

// 保存标记异常
export function saveExamFlag(papams: ExamFlagPaparms) {
    return axios.post(`/teacher/saveExamFlag`, qs.stringify(papams));
}

// 删除标记异常
export function deleteExamFlag(flagId: number) {
    return axios.post(`/teacher/deleteExamFlag`, qs.stringify({ flagId }));
}

export interface ExamFlagListItem {
    id: number; //异常ID
    examId: number; //考核ID
    studentNo: string; //学号
    flag: string; //标记
    createTime: string; //创建时间
    updateTime: string;
    createUser: number;
    createUserName: string;
    updateUser: number;
    updateUserName: string;
}

// 获取标记异常列表
export function getExamFlagList(studentNo: string, examId: string) {
    return axios
        .post<SuccessData<ExamFlagListItem[]>>(
            `/teacher/getExamFlagList`,
            qs.stringify({ studentNo, examId })
        )
        .then(res => res.data.data);
}

// 监考页面补充附件
export function saveExtraUploadFile(
    examId: string,
    file: string,
    stuNo: string
) {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios
        .post(
            `/teacher/saveExtraUploadFile`,
            qs.stringify({ examId, file, stuNo }),
            { headers: { batchNo } }
        )
        .then(res => res.data.data);
}

export interface FileItem {
    id: string;
    fileName: string;
    teacherName: string;
    time: string;
}

export interface catchPhotoItem {
    fileUrl: string; //文件地址
    time: string; //时间
}

export interface ExamInfoByStuItem {
    flagList: ExamFlagListItem[]; //异常标签
    subject: string; //专业
    sex: string; //性别
    className: string; //班级
    stuName: string; //姓名
    allExtraFile: FileItem[]; //教师补传
    submitTime: string; //提交时间
    joinInTime: number; //作答时间  单位:分钟
    department: string; //学院
    examTime: number; //考试时间
    firstStartTime: string; //第一次打开试卷时间
    stuNo: string; //学号
    allLeaveTime: string[]; //离开页面次数
    examAfter: catchPhotoItem[]; //交卷后抓拍
    examBefore: catchPhotoItem[]; //开考前抓拍
    examIn: catchPhotoItem[]; //考试中抓拍
}

// 监考详情
export function getExamInfoByStu(examId: string, studentNo: string) {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios
        .post<SuccessData<ExamInfoByStuItem>>(
            `/teacher/getExamInfoByStu`,
            qs.stringify({ examId, studentNo, batchNo })
        )
        .then(res => res.data.data);
}

//删除附件
export function removeExamInfoExtraFile(id: string) {
    return axios.post(`/teacher/removeExamInfoExtraFile`, qs.stringify({ id }));
}

//打包下载学生试卷
export function downloadAllExamPaper(
    examId: string,
    courseNo: string,
    courseSeq: string
) {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios.post(
        `/teacher/downloadAllExamPaper`,
        qs.stringify({ examId, courseNo, courseSeq }),
        { headers: { batchNo } }
    );
}

export enum downloadState {
    success = "0", //可下载
    loading = "1", //等待中
    producting = "2", //生成中
    error = "3" //已失败
}

export interface ZipPaperListItem {
    persistId: string;
    uuid: string;
    url: string;
    statusCode: string; //状态为0的时候才能下载
    status: string;
    fileName: string;
}

//获取试卷下载任务列表
export function getZipPaperList(
    examId: string,
    courseNo: string,
    courseSeq: string
) {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;
    return axios
        .get<SuccessData<{ [key: string]: ZipPaperListItem[] }[]>>(
            `/teacher/getZipPaperList`,
            { params: { examId, courseNo, courseSeq, batchNo } }
        )
        .then(res => res.data.data);
}

/**
 * 批量导入试题
 */
export function importExamFromExcel(file: File, examId: string) {
    const headers = { "Content-Type": "multipart/Form-data" };
    const formData = new FormData();
    formData.append("file", file);
    formData.append("examId", examId);
    return axios.post(`/teacher/importExamPaperExcel`, formData, { headers });
}

export enum ImportState {
    none = "0",
    success = "1",
    error = "2"
}

export interface ImportResultListItem {
    createTime: string;
    examId: string;
    fileName: string;
    state: ImportState;
}

/**
 * 考核导入情况查询
 */
export function findImportByExamIds(examId: string) {
    return axios
        .post<SuccessData<ImportResultListItem[]>>(
            `/teacher/findImportByExamIds`,
            qs.stringify({ examId })
        )
        .then(res => res.data.data);
}

/**
 * Excel模板下载
 */
export function downloadExamPaperTemplate() {
    return download("GET", "/teacher/downloadExamPaperTemplate").then(res => {
        let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
        );

        let url = window.URL.createObjectURL(res.data);
        let link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    });
}

/**
 * 导出失败文件
 * @param fileName
 * @returns
 */
export function downloadExamPaperErrExcel(fileName: string) {
    return download(
        "GET",
        `/teacher/downloadExamPaperErrExcel?fileName=${fileName}`
    ).then(res => {
        let url = window.URL.createObjectURL(res.data); //表示一个指定的file对象或Blob对象
        let link = document.createElement("a");
        link.href = url;
        link.download = fileName; //命名下载名称
        link.click(); //点击触发下载
        window.URL.revokeObjectURL(url); //下载完成进行释放
    });
}

/**
 * 手动题库选题习题详情
 */
export interface QuestionDetailItemParamsType {
    questionId: string;
}
export interface QuestionDetailItemSaveParamsType {
    questionId: string;
    score: number;
}
export interface ResultQuestionItem {
    queTypeId: 1 | 2 | 3 | 4 | 5 | 6; //题型 1：单选 2：多选 3：判断 5：填空
    id: string; //习题id
    contentText: string; // 题干
    optionModelList: ResultOptions[]; //选项集合
}
export interface ResultOptions {
    description: string; //内容
    isRight: "0" | "1"; //0：错误 1：正确
}
// <SuccessData<ResultQuestionItem[]>>
export function getQuestionDetailsByManual(
    params?: QuestionDetailItemParamsType[]
) {
    return axios({
        headers: {
            "Content-Type": "application/json;"
        },
        method: "post",
        url: "/teacher/exercise/getQuestionDetailsByManual",
        data: JSON.stringify(params)
    }).then(res => {
        return res.data.data;
    });
}

interface saveExamParamsType {
    examId: string;
    data: QuestionDetailItemSaveParamsType[];
}
export function saveExamPaperByManual(params: saveExamParamsType) {
    return axios({
        headers: {
            "Content-Type": "application/json;"
        },
        method: "post",
        url: "/teacher/exercise/saveExamPaperByManual",
        data: JSON.stringify(params)
    }).then(res => {
        return res.data;
    });
}

export interface EvaluationListItem {
    courseName: string;
    courseNo: string;
    courseSeq: string;
    batchNo: string;
    startTime: string; // 评教开始时间
    endTime: string; // 评教结束时间
    evaluationCode: string; // 评教code
    evaluationId: string; // 评教id
    evaluationName: string; // 评教名称
    examEndTime: string; //  考核截止时间
    examId: string; // 考核id
    examInfo: string; // 考核试卷id
    examName: string; // 考核名称
    examStartTime: string; // 考核开始时间
    examType: ExamType; // 考核类型
    expireStatus: string; // 评教过期状态, 0: 未开始, 1: 进行中, 2: 已结束
    file: string; // 七牛文件地址
    fileViewUrl: string; // 文件预览url
    isPublish: BooleanValue; // 考核发布状态
    markTeacherName: string; // 批卷老师
    markTeacherNo: string; // 批卷老师编号
    teacherNo: string; // 评教教师编号
    topicTeacherName: string; // 出题老师
    topicTeacherNo: string; // 出题老师编号
    mainTeacherName: string; // 主授课教师姓名
    mainTeacherNo: string; // 主授课教师编号
}

/**
 * 试卷评教列表
 */
export function paperEvaluationList() {
    const token = getToken();
    return axios
        .get<SuccessData<EvaluationListItem[]>>(
            "/teacher/evaluation/paperEvaluationList",
            { headers: { token } }
        )
        .then(res => res.data.data);
}

/**
 * 保存评卷
 * @param evaluationId
 * @param fileUrl
 */
export function savePaperEvaluationFileUrl(
    evaluationId: string,
    fileUrl: string
) {
    const token = getToken();
    return axios.post(
        "/teacher/evaluation/savePaperEvaluationFileUrl",
        qs.stringify({ evaluationId, fileUrl }),
        { headers: { token } }
    );
}

/**
 * 删除评卷
 * @param evaluationId
 * @param fileUrl
 */
export function removePaperEvaluationFileUrl(evaluationId: string) {
    return savePaperEvaluationFileUrl(evaluationId, "");
}

export interface EvaluationList2Item {
    batchNo: string;
    teacherName: string;
    evaluationName: string;
    examName: string;
    examEndTime: string;
    examType: ExamType;
    isPublish: string;
    evaluationId: string;
    fileViewUrl: string;
    courseName: string;
    file: string;
    evaluationCode: string;
    courseNo: string;
    examId: string;
    startTime: string;
    expireStatus: string;
    courseSeq: string;
    endTime: string;
    examStartTime: string;
}

/**
 * 试卷评教列表(评价我的)
 */
export function paperEvaluationList2() {
    return axios
        .get<SuccessData<EvaluationList2Item[]>>(
            "/teacher/evaluation/paperEvaluationList2"
        )
        .then(res => res.data.data);
}

/**
 * 监考列表统计数据
 */
export function getMonitorListStatistic(refreshList: string) {
    return axios
        .get<
            SuccessData<{
                downloadNum: number; // 下载附件人数
                multiScreenNum: number; // 多屏，双屏人数
                notJoinNum: number; // 未参加人数
                leaveScreenNum: number; // 切屏人数
                ipAbnormalNum: number; // IP异常人数
                loginAbnormalNum: number; // 登录异常人数
            }>
        >("/teacher/getMonitorListStatistic", { params: { refreshList } })
        .then(res => res.data.data);
}

export interface InvigilationExamItem {
    examId: string;
    examName: string;
}

interface InvigilationMonitor {
    monitorName: string;
    monitorNo: string;
}

export interface InvigilationItemInfo {
    examId: number;
    examName: string;
    courseNo: string;
    beginTime: string;
    endTime: string;
    duration: number;
    studentNo: string;
    studentName: string;
    ban: BooleanValue; // 是否被仅靠
    courseSeq: string;
    batchNo: string;
    customerCode: string; //租户code
    paperTeacherName: string; // 出卷人名称
    paperTeacherNo: string; // 出卷人编号
    monitorList: InvigilationMonitor[]; // 监考老师列表
    firstStartTime: string; // 进入时间
    submitTime: string; // 交卷时间
    examFlag: BooleanValue; // 是否交卷（0.否，1是）
    fileNum: number; // 附件数量
    uploadFileNum: number; // 附件数量
    fullCourse: string; //课程信息字符串
    joinFlag: BooleanValue;
}

export interface NotJoinExamPeopleItem extends InvigilationItemInfo {
    examFlag: BooleanValue; // 是否参加（0.未参加，1.已参加）
}

interface NotJoinExamPeopleList {
    conditionQueryList: InvigilationExamItem[];
    dataList: NotJoinExamPeopleItem[];
}

/**
 * 未参考人员列表
 */
export function getNotJoinExamPeopleList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<NotJoinExamPeopleList>>(
            `/teacher/getNotJoinExamPeopleList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface ExamPhotoItem {
    time: string;
    url: string;
}

export interface StudentFaceListItem extends InvigilationItemInfo {
    studentFaceList: ExamPhotoItem[];
}

interface ExamStudentFaceList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentFaceListItem[];
}

/**
 * 考生抓拍列表
 * @param query
 */
export function getExamStudentFaceList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentFaceList>>(
            `/teacher/getExamStudentFaceList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface LeaveScreenItem {
    leaveName: string;
    time: string;
}

export interface StudentLeaveScreenListItem extends InvigilationItemInfo {
    leaveScreenList: LeaveScreenItem[];
    leaveScreenNum: number;
}

interface ExamStudentLeaveScreenList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentLeaveScreenListItem[];
}

/**
 * 考生切屏列表
 * @param query
 */
export function getExamStudentLeaveScreenList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentLeaveScreenList>>(
            `/teacher/getExamStudentLeaveScreenList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface MultiScreenListItem {
    leaveName: string; // 多屏统一名称
    time: string; // 多屏时间
}

export interface StudentMultiScreenListItem extends InvigilationItemInfo {
    multiScreenList: MultiScreenListItem[];
    multiScreenNum: number;
    multiScreenCount: number;
}

interface ExamStudentMultiScreenList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentMultiScreenListItem[];
}

/**
 * 考生多屏列表
 * @param query
 */
export function getExamStudentMultiScreenList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentMultiScreenList>>(
            `/teacher/getExamStudentMultiScreenList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface DownloadListItem {
    fileName: string; // 文件名称
    fileUrl: string; // 文件路径
    time: string; // 多屏时间
}

export interface StudentDownloadRecordListItem extends InvigilationItemInfo {
    downloadList: DownloadListItem[];
}

interface ExamStudentDownloadRecordList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentDownloadRecordListItem[];
}

/**
 * 考生下载附件记录列表
 * @param query
 */
export function getExamStudentDownloadRecordList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentDownloadRecordList>>(
            `/teacher/getExamStudentDownloadRecordList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface PrintScreenListItem {
    time: string;
    url: string;
}

export interface StudentPrintScreenListItem extends InvigilationItemInfo {
    printScreenNum: number;
    printScreenList: PrintScreenListItem[];
}

interface ExamStudentPrintScreenList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentPrintScreenListItem[];
}

/**
 * 考生抓屏列表
 * @param query
 */
export function getExamStudentPrintScreenList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentPrintScreenList>>(
            `/teacher/getExamStudentPrintScreenList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

interface StudentSubmitPaperListItem extends InvigilationItemInfo {
    downloadList: DownloadListItem[];
    multiScreenList: MultiScreenListItem[];
    leaveScreenList: LeaveScreenItem[];
    studentFaceList: StudentFaceListItem[];
}

interface ExamStudentSubmitPaperList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentSubmitPaperListItem[];
}

/**
 * 已交卷考生列表
 * @param query
 */
export function getExamStudentSubmitPaperList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentSubmitPaperList>>(
            `/teacher/getExamStudentSubmitPaperList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

export interface StudentAllRecordListItem extends InvigilationItemInfo {
    downloadList: DownloadListItem[];
    multiScreenList: MultiScreenListItem[];
    leaveScreenList: LeaveScreenItem[];
    studentFaceList: StudentFaceListItem[];
    printScreenList: PrintScreenListItem[];
}

export interface ExamStudentAllRecordList {
    conditionQueryList: InvigilationExamItem[];
    dataList: StudentAllRecordListItem[];
}

/**
 * 参考全记录列表
 * @param query
 */
export function getExamStudentAllRecordList(query: {
    examId?: string;
    studentName?: string;
}) {
    const { examId = "", studentName = "" } = query;

    return axios
        .get<SuccessData<ExamStudentAllRecordList>>(
            `/teacher/getExamStudentAllRecordList?examId=${examId}&studentName=${studentName}`
        )
        .then(res => res.data.data);
}

/**
 * 全监考列表
 * @param query
 */
export interface getExamStudentAllMonitorListProps {
    examId: string;
    studentName?: string;
    course?: string;
    isOldInvigilation?: string; //是否是旧监考列表
}
export function getExamStudentAllMonitorList(
    params: getExamStudentAllMonitorListProps
) {
    return axios
        .get<SuccessData<ExamStudentAllRecordList>>(
            `/teacher/getExamStudentAllMonitorList`,
            { params }
        )
        .then(res => res.data.data)
        .then(res => {
            const { course } = params;
            if (course && course.includes("_") && course.length > 0) {
                res.dataList = res.dataList.filter(item => {
                    return item.fullCourse.includes(course);
                });
            }

            return res;
        });
}

// 未参考人员详细信息 http://172.16.30.51:3000/project/35/interface/api/3503
export interface getExamInfoProps {
    courseNo: string;
    courseSeq: string;
    customerCode: string;
    batchNo: string;
    studentNo: string;
    examId: number;
}
export interface NotJoinItemInfo extends InvigilationItemInfo {
    courseTeacherName: string; // 授课人姓名
    courseTeacherNo: string; //授课人编号
}
export function getNotJoinExamPeopleInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<NotJoinItemInfo>>(
            "/teacher/getNotJoinExamPeopleInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 考生抓拍详细信息 http://172.16.30.51:3000/project/35/interface/api/3510
export interface StudentFaceItemInfo extends InvigilationItemInfo {
    studentFaceList: ExamPhotoItem[];
}
export function getExamStudentFaceInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<StudentFaceItemInfo>>(
            "/teacher/getExamStudentFaceInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 考生切屏细信息 http://172.16.30.51:3000/project/35/interface/api/3517
export interface LeaveScreenItemInfo extends InvigilationItemInfo {
    leaveScreenList: LeaveScreenItem[];
}
export function getExamStudentLeaveScreenInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<LeaveScreenItemInfo>>(
            "/teacher/getExamStudentLeaveScreenInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 考生多屏细信息 http://172.16.30.51:3000/project/35/interface/api/3524
export interface MultiScreenItemInfo extends InvigilationItemInfo {
    multiScreenList: MultiScreenListItem[];
}
export function getExamStudentMultiScreenInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<MultiScreenItemInfo>>(
            "/teacher/getExamStudentMultiScreenInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 下载附件 http://172.16.30.51:3000/project/35/interface/api/3531
export interface DownloadRecordItemInfo extends InvigilationItemInfo {
    downloadList: DownloadListItem[];
    downloadNum: number; //下载次数
}
export function getExamStudentDownloadRecordInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<DownloadRecordItemInfo>>(
            "/teacher/getExamStudentDownloadRecordInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 抓屏 http://172.16.30.51:3000/project/35/interface/api/3545
export interface PrintScreenItemInfo extends InvigilationItemInfo {
    printScreenList: PrintScreenListItem[];
    printScreenNum: number; //抓屏次数
}
export function getExamStudentPrintScreenInfo(data: getExamInfoProps) {
    return axios
        .post<SuccessData<PrintScreenItemInfo>>(
            "/teacher/getExamStudentPrintScreenInfo",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

// 全过程记录详情 http://172.16.30.51:3000/project/35/interface/api/3608
export interface DetailItem {
    TIME: string;
    desc: string;
}
export interface LogItemInfo {
    loginTime: string[];
    system: string[];
    logDetail: DetailItem[];
    ip: string[];
    browser: string[];
    startExamTime: string;
}
export function getStudentExamLog(data: { studentNo: string; examId: number }) {
    return axios
        .post<SuccessData<LogItemInfo>>(
            "/teacher/getStudentExamLog",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}
// 获取监考考核列表 http://172.16.30.51:3000/project/35/interface/api/3573
export interface InvigilationOptionItem {
    examId: string; //考核id
    examName: string; //考核名称
}
export interface InvigilationOptionList {
    conditionQueryList: InvigilationOptionItem[];
}
export function getExamListByInvigilation() {
    return axios
        .get<SuccessData<InvigilationOptionList>>(
            "/teacher/getExamListByInvigilation"
        )
        .then(res => res.data.data.conditionQueryList);
}

// 获取监考考核列表
export function getCourseListByExam(examId: string) {
    return axios
        .post<SuccessData<CourseListItem[]>>(
            "/teacher/getCourseListByExam",
            qs.stringify({ examId })
        )
        .then(res => res.data.data);
}
// 获取监考考核列表 http://172.16.30.51:3000/project/35/interface/api/3587
export interface InvigilationStuListItem {
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    studentNo: string; //学生编号
    studentName: string; //学生姓名
    detailId: string; //明细id
    meetingRoom: string; //考场信息
    courseName: string; //课程名称
    masterTeacherId: string; //主监考老师编号，多个逗号分隔
    masterTeacherName: string; //主监考老师姓名，多个逗号分隔
    assistantTeacherId: string; //负责监考老师编号，多个逗号分隔
    assistantTeacherName: string; //负责监考老师姓名，多个逗号分隔
    lectureTeacherId: string; //授课老师编号
    lectureTeacherName: string; //授课老师姓名
}
export interface getStuProps {
    examId: string;
    search: string;
}
export function getInvigilationStudentByExamId(data: getStuProps) {
    return axios
        .post<SuccessData<InvigilationStuListItem[]>>(
            "/teacher/getInvigilationStudentByExamId",
            qs.stringify(data)
        )
        .then(res => res.data.data)
        .then(data => {
            return data.map(item => {
                let assistantTeacherId = item.assistantTeacherId.split(",");
                let assistantTeacherName = item.assistantTeacherName
                    .split(",")
                    .map((c, i) => {
                        return `${c}(${assistantTeacherId[i]})`;
                    })
                    .join(",");
                return {
                    ...item,
                    assistantTeacherName
                };
            });
        });
}

//保存考场信息
export interface updateMeetingProps {
    detailId: string; //明细id，多个逗号
    meetingRoom: string; //考场信息
    examId: string;
    studentNo: string; //学生编号，多个逗号
}
export function updateMeetingRoom(data: updateMeetingProps) {
    return axios
        .post("/teacher/updateMeetingRoom", qs.stringify(data))
        .then(res => res.data.data);
}

export interface IpAbnormalItem extends InvigilationItemInfo {
    studentName: string;
    ipAbnormalNum: string;
    studentNo: string;
}

interface IpAbnormalList {
    conditionQueryList: InvigilationExamItem[];
    dataList: IpAbnormalItem[];
}

/**
 * ip异常列表
 * @param examId
 * @param studentName
 */
export function getIpAbnormalStudentList(examId: string, studentName: string) {
    return axios
        .post<SuccessData<IpAbnormalList>>(
            "/teacher/getIpAbnormalStudentList",
            qs.stringify({ examId, studentName })
        )
        .then(res => res.data.data);
}

export interface IpAbnormalStudentInfoListItem {
    studentName: string;
    studentNo: string;
    newIp: string;
    time: string;
    actionName: string;
}

/**
 * ip异常详情列表
 * @param examId
 * @param studentNo
 */
export function getIpAbnormalStudentInfoList(
    examId: number,
    studentNo: string
) {
    return axios
        .post<SuccessData<IpAbnormalStudentInfoListItem[]>>(
            "/teacher/getIpAbnormalStudentInfoList",
            qs.stringify({ examId, studentNo })
        )
        .then(res => res.data.data);
}

export interface IpRange {
    ipRange: string;
    name: string;
}

/**
 * 获取ip范围
 * @param examId
 */
export function getIpRange(examId: string) {
    return axios
        .post<SuccessData<IpRange[]>>(
            "/teacher/getIpRange",
            qs.stringify({ examId })
        )
        .then(res => res.data.data);
}

export interface RoomIpListItem {
    id: string;
    name: string;
    ipRange: string;
}

/**
 * 获取机房ip列表
 * @param name
 */
export function getMachineRoomIpList(name?: string) {
    return axios
        .post<SuccessData<RoomIpListItem[]>>(
            "/teacher/getMachineRoomIpList",
            qs.stringify({ name })
        )
        .then(res => res.data.data);
}

/**
 * 机房维护
 * @param machineRoomId
 * @param id
 */
export function saveIpRange(id: Key[], machineRoomId: string) {
    return axios.post(
        "/teacher/saveIpRange",
        qs.stringify({ machineRoomId, id: id.join() })
    );
}

export interface LoginAbnormalItem extends InvigilationItemInfo {
    loginNum: number;
}

interface LoginAbnormalList {
    conditionQueryList: InvigilationExamItem[];
    dataList: LoginAbnormalItem[];
}
/**
 * 多次登录列表
 * @param examId
 * @param studentName
 */
export function getLoginAbnormalStudentList(
    examId: string,
    studentName: string
) {
    return axios
        .post<SuccessData<LoginAbnormalList>>(
            "/teacher/getLoginAbnormalStudentList",
            qs.stringify({ examId, studentName })
        )
        .then(res => res.data.data);
}

/**
 * 列表修改成绩
 */
export interface UpdateExamStuScore {
    examid: string;
    score: number;
    studentid: string;
    paperid: string;
}
export function updateExamStuScore(data: UpdateExamStuScore) {
    return axios.post(`/teacher/savePaperFinalScore`, qs.stringify(data));
}
